import { DRAG_AND_DROP_CONSTANTS } from './constants';
import { withNewPageIds } from './withNewPageIds';
import { without } from 'lodash';

const reorder = ({ list, element, index }) => {
	const result = without(list, element);
	result.splice(index, 0, element);

	return result;
};

export const reorderSingleDrag = (args) => {
	const { type, source, entities, destination, draggableId, selectedPages } = args;

	if (type === DRAG_AND_DROP_CONSTANTS.COLUMN) {
		const newOrder = reorder({ list: entities.columnOrder, element: draggableId, index: destination.index });
		const updatedData = { ...entities, columnOrder: newOrder };

		return { updatedData, orderedSelectedPageIds: selectedPages };
	}

	// moving in the same list
	if (source.droppableId === destination.droppableId) {
		const column = entities.columns[source.droppableId];
		const reordered = reorder({ list: column.pageIds, element: draggableId, index: destination.index });

		const updatedData = {
			...entities,
			columns: {
				...entities.columns,
				[column.id]: withNewPageIds(column, reordered),
			},
		};

		return { updatedData, orderedSelectedPageIds: selectedPages };
	}

	const { [source.droppableId]: home, [destination.droppableId]: foreign, ...restColumns } = entities.columns; // moving to a new list
	const pageId = home.pageIds[source.index]; // the id of the page to be moved
	const newHomePageIds = [...home.pageIds]; // remove from home column
	newHomePageIds.splice(source.index, 1);

	const newForeignPageIds = [...foreign.pageIds]; // add to foreign column
	newForeignPageIds.splice(destination.index, 0, pageId);

	const updatedData = {
		...entities,
		columns: {
			...restColumns,
			[foreign.id]: withNewPageIds(foreign, newForeignPageIds),
		},
	};

	if (home.id !== DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE && newHomePageIds.length === 0) {
		updatedData.columnOrder = without(entities.columnOrder, home.id); // if detected column is empty after drag - filtred it
	} else {
		updatedData.columns[home.id] = withNewPageIds(home, newHomePageIds);
	}

	return { updatedData, orderedSelectedPageIds: selectedPages };
};
